module.exports = "/assets/data/5dad2e913fc39192c04803e7c081e174-LU1.data.json";